(function ($) {

    var dropdown = $('.OE-Dropdown');

    // Topics Dropdown

    dropdown.each(function () {
        var $this = $(this);

        $this.find('.OE-Dropdown-button').on('click', function (e) {
            e.stopPropagation();
            var $this = $(this),
                $parent = $(this).parent();

            if ($parent.hasClass('open')) {
                $parent.removeClass('open');
            } else {
                $('.OE-Dropdown').removeClass('open');
                $this.find('.OE-Dropdown-button').removeClass('open');
                $parent.addClass('open');
            }
        });

        $this.find('.OE-Dropdown-menu').on('click', function (e) {
            e.stopPropagation();
        });

        $this.find('.OE-Dropdown-menu li a').on('click', function (e) {
            var dropdownButtonText = $(this).text();
            $this.removeClass('open');
            $this.find('.OE-Dropdown-button-text').text(dropdownButtonText);
        });

        $('html, body').on('click', function (e) {
            $this.removeClass('open');
        });
    });

})(jQuery);